/**
 * Chater's measurement.
 * Book clicks send Google Ads conversion AW-16570687270/NoFiCKHjzLIZEKa-wt09.
 * GiftPro clicks and enquiry submits are dataLayer-only (no Ads labels).
 * Do not preventDefault here. Widget open is handled in chaters-sevenrooms.js.
 * Do not poll SevenRooms.
 */
(function () {
  var config = window.CHATERS_TRACKING;
  if (!config) return;

  window.dataLayer = window.dataLayer || [];

  function hrefOf(link) {
    return String((link && (link.href || link.getAttribute("href"))) || "");
  }

  function isBookLink(href) {
    return href.toLowerCase().indexOf(config.bookHost) !== -1;
  }

  function isGiftProLink(href) {
    return href.toLowerCase().indexOf(config.giftproHost) !== -1;
  }

  document.addEventListener(
    "click",
    function (event) {
      var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
      if (!link) return;
      var href = hrefOf(link);
      if (!href || href.charAt(0) === "#") return;

      if (isBookLink(href) && typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: config.bookConversion });
      }

      if (isGiftProLink(href)) {
        window.dataLayer.push({ event: "chaters_giftpro_click" });
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.id) return;
      if (form.id === "GroupEnquiry") {
        window.dataLayer.push({ event: "chaters_groups_enquiry_submit" });
      }
      if (form.id === "ChristmasEnquiry") {
        window.dataLayer.push({ event: "chaters_christmas_enquiry_submit" });
      }
    },
    true
  );
})();
